import React from 'react'
import './donation.css';
import bank from '../../assets/images/image-30_1image 30.png';
import dialog from '../../assets/images/dialog_logo_1dialog_logo.png';

const Donation = () => {
  return (
    <div className="background-color">
       <div id="projects" className="section">
      <div className="container">
        <h1 className="h1-left">Make a donation</h1>
        <p className="p-left">The donation will be added to the separate fund to which you have requested and will be directly monitored by our team and deploy it to reach the solution of the project. The website will be updated once in two weeks with the progress of the project and the progress of the donation.</p>
        <div className="make-a-transfer-heading">
          <img src={bank} loading="lazy" alt="" srcset="" />
          <h3 className="donation-page">Make a bank transfer</h3>
        </div>
        <div className="row">
          <div className="col-md-7 col-12">
            <p className="p-left">For both domestic and international transfers. To make a donation via bank wire transfer, use the information below.
              <br />
              <br />
              Contact: Customer Service  <br />
              Phone: +94 114 896 896  <br />
              Email: <a href="mailto:info@gammadda.lk">info@gammadda.lk</a></p>

          </div>
          <div className="who-we-are col-md-5 col-12">
            <p className="p-left bank-details">
              <strong className="bold-text-3">Bank of Ceylon</strong><br />
              Bank Name: Bank of Ceylon<br />
              Bank Branch: Corporate Branch<br />
              Bank Account Number: 80144512<br />
              SWIFT Code: BCEYLKLXXXX
              <br /><br /><br />
              <strong className="bold-text-4">Nation’s Trust Bank</strong>
              <br />Bank Name: Nation&#x27;s Trust Bank<br />
              Bank Branch: Cinnamon Gardens<br />
              Bank Account Number: 100111112335<br />
              SWIFT Code: NTBCLKLXXXX
              <br /><br /><br />
              <strong className="bold-text-4">Hatton National Bank</strong><br />
              Bank Name: Hatton National Bank<br />
              Bank Branch: Head Office<br />
              Bank Account Number: 003010514477<br />
              SWIFT Code: HBLILKLX</p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="make-a-transfer-heading">
          <img src={dialog} loading="lazy" alt="" />
          <h3 className="donation-page">Donate through Dialog</h3>
        </div>
        <div className="row">
          <div className="col-md-7 col-12">
            <p className="p-left">It is easier for you to simply donate to Gammadda through your Dialog number. Simply follow the instructions.</p>
          </div>
          <div className="who-we-are col-md-5 col-12">
            <p className="p-left bank-details"><strong className="bold-text">Instructions:<br /></strong>‍<br />From your Dialog mobile type <strong>GAM</strong> &amp; send it to <strong>7788</strong></p>
          </div>
        </div>
      </div>
    </div>
    </div>
   
  )
}

export default Donation